var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5"},[(_vm.icon)?_c('span',{class:_vm.icon,staticStyle:{"font-size":"75px"}}):_vm._e(),_vm._t("default"),_c('h1',{staticClass:"pt-4"},[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }